import type { ReactNode } from 'react';
import './components.css';

interface Pair {
  label: string;
  value: ReactNode;
  mono?: boolean;
}

export function KeyValueGrid({ items, cols = 2 }: { items: Pair[]; cols?: number }) {
  return (
    <dl className="iris-kv" style={{ gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` }}>
      {items.map((p, i) => (
        <div key={i} className="iris-kv-row">
          <dt>{p.label}</dt>
          <dd className={p.mono ? 'mono' : ''}>{p.value}</dd>
        </div>
      ))}
    </dl>
  );
}
